export default __webpack_public_path__ + "static/media/DJprizes.3511da5f.png";